import { useForm } from 'react-hook-form';

import { SectionType } from 'sections/TabWrap';
import { EditForm } from 'sections/EditForm';

import { formData } from './form.data';

const useSeo = () => {
  const { register } = useForm();

  const sections: SectionType[] = [
    {
      id: 1,
      content: <EditForm onSubmit={() => null} data={formData} register={register} />,
    },
  ];

  return {
    sections,
  };
};

export { useSeo };
